import React from 'react';
import PropTypes from 'prop-types';

export default function ToggleSwitch(props) {
  let { label, ...args } = props;
  return (
    <label className='km__c--switch'>
      <input type='checkbox' {...args} />
      <span className='km__c--switch-slider'></span>
      <span className='km__c--switch-label'>{label}</span>
    </label>
  );
}
ToggleSwitch.propTypes = {
  label: PropTypes.string,
};
